import { selectActiveTutorialConfig, selectTutorialConfig } from "../../../selectors/selectTutorial";
export var selectTutorialConfigData = function (state) {
    var tutorialStepConfig = selectActiveTutorialConfig(state);
    var nextTutorialStepConfig;
    if (tutorialStepConfig && tutorialStepConfig.nextStep) {
        nextTutorialStepConfig = selectTutorialConfig(state, tutorialStepConfig.nextStep);
    }
    return {
        nextTutorialStepConfig: nextTutorialStepConfig,
        tutorialStepConfig: tutorialStepConfig,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/selectors/selectTutorialConfigData.ts
// module id = 116
// module chunks = 3